import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sidebar from "../images/svg/sidebar.svg";
import setting from "../images/svg/settings.svg";
import signed from "../images/svg/signed.svg";
import waivers from "../images/svg/waivers.svg";
import dashboard from "../images/svg/dashboard.svg";
import billing from "../images/svg/billing.svg";
import logo from "../images/svg/sidebar-logo.svg";
import qr from "../images/svg/qr.svg";
import smallLogo from "../images/svg/mini-logo.svg";
import { useBusinessLogout } from '../business/commoncomponents/useBusinessLogout';

const menuItems = [
  { name: "Dashboard", icon: dashboard, nvlink: "/business/dashboard" },
  { name: "Waivers", icon: waivers, nvlink: "/business/waivers" },
  { name: "Signed", icon: signed, nvlink: "/business/waivers/signatures" },
  { name: "QR Codes", icon: qr, nvlink: "/business/qr-codes" },
  { name: "Settings", icon: setting , nvlink: "/business/edit-profile"},  
  { name: "Locations", icon: setting , nvlink: "/business/locations"},
  { name: "Billing", icon: billing , nvlink: "/business/dashboard"},
];



const Sidebar = () => {

  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useBusinessLogout();

  // check on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setCollapsed(true); // collapse on small screens
      } else {
        setCollapsed(false); // expand on large screens
      }
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      {/* mobile button */}
      {/* <div
        className={`fixed top-0 left-0 right-0 pt-2 pl-4 z-10 md:hidden  bg-background ${collapsed ? "" : "hidden"}`}
      >
        <button
          onClick={() => setCollapsed(!collapsed)}
          className={`size-6 lg:hidden`}
        >
          <img src={sidebar} alt="sidebar" className="object-contain" />
        </button>
      </div> */}
      {/* ✅ Sidebar */}
      <aside
        className={`${
          collapsed
            ? "w-10 md:w-14"
            : "lg:w-[250px] xl:w-[280px] max-lg:fixed max-lg:top-0 max-lg:bottom-0 max-lg:left-0 max-lg:right-0 max-lg:bg-black/40 "
        } h-screen`}
       
      >
        <div
          className={`${collapsed ? "px-0 " : "px-4 w-52 lg:w-full"}  h-full bg-white border-r border-stroked py-5 lg:py-8 lg:px-4 `}
        >
          {/* Logo */}
          <div
            className={`h-10 relative flex items-center ${collapsed && "!justify-center"} justify-between mb-6`}
          >
            {!collapsed && (
              <Link to="/business/dashboard" className="block w-10 lg:w-[180px] h-fit">
                <img
                  src={logo}
                  alt="logo"
                  className="w-full h-full hidden lg:block"
                />
                <img
                  src={smallLogo}
                  alt="logo"
                  className="w-full h-full block lg:hidden"
                />
              </Link>
            )}

            <button
              onClick={() => setCollapsed(!collapsed)}
              className={`size-6 absolute top-2  z-50 lg:hidden ${collapsed ? "right-2 md:right-4" : "right-0"}`}
            >
              <img src={sidebar} alt="sidebar" className="object-contain" />
            </button>
          </div>

          {/* Menu */}
          <nav className="space-y-1">
            {menuItems.map((item, index) => {
              const Icon = item.icon;
              const NvLink = item.nvlink;
              return (
                <Link to={NvLink} className="block w-10 lg:w-[180px] h-fit">
                  <button
                    key={index}
                    className={`w-full flex items-center gap-3 lg:px-4 py-2 rounded-md text-base font-medium text-darkLighted hover:bg-highlited/15 transition-all duration-300 ${collapsed ? "justify-center" : ""}`}
                  >
                    <img src={item.icon} alt="icon" className="size-5 md:size-6" />
                    {!collapsed && item.name}
                  </button>
                </Link>
              );
            })}

          <button
            key={"logoutkey"}
            className={`w-full flex items-center gap-3 lg:px-4 py-2 rounded-md text-base font-medium text-darkLighted hover:bg-highlited/15 transition-all duration-300 ${collapsed ? "justify-center" : ""}`}
            onClick={() => {
              logout();
            }}
          >
            <img src={setting} alt="icon" className="size-5 md:size-6" />
            {!collapsed && "Logout"}
          </button>

          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
